exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app,.maxHeight,body,html,main{height:100vh}", ""]);

// exports
